import Header from "../Header";
import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {createConditionalRequire} from "../../utils";
import {submitStep} from "../../network";
import ReactGA from "react-ga";

const TimelineAndGrading = ({nextStep, currentFormStep, maxStep}) => {
    useEffect(() => {
        ReactGA.pageview(window.location.pathname + "/timelineAndGrading");
    }, []);
    const [isLoading, setLoading] = useState(false);
    const onSubmit = data => {
        setLoading(true);
        submitStep("timeline and grading", data)
            .then(() => {
                setLoading(false);
                nextStep()
            })
    };
    const {register, handleSubmit, errors, getValues} = useForm();
    return (<>
        <Header title="Mida millal teha ja kuidas kujuneb hinne?"/>
        <progress className="progress is-link" value={currentFormStep} max={maxStep}/>
        <section className="section">
            <div className="container">
                <p className="text">
                    Siin saad ülevaate sellest, millised on olulised sündmused semestri jooksul ja kuidas kujuneb hinne. 
                    Detailsemat infot saad varsti lugeda Moodle'i keskkonnast ja ka esimesel loengul!
                </p>
            </div>
            <div className="container">
                <h1 className="subtitle">
                    Iganädalased ülesanded
                </h1>
                <p className="text">
                    Selles aines ootame Sinult, et Sa lahendad iga nädal iseseisvalt ülesandeid.
                    Ülesanded lähevad iga kord veidi keerulisemaks, seepärast ei tasu nädalat vahele jätta - nii on Sul palju mõnusam ja efektiivsem õppida.
                </p>
                <p className="text">
                    Praktiliselt soovitame:
                </p>
                <ul className="list">
                    <li>
                        alustada ülesannetega võimalikult varakult
                    </li>
                    <li>
                        esitada ülesanded tähtajaks, sest tähtaja ületades saab vähem punkte
                    </li>
                    <li>
                        ülesande kohta saame anda Sulle personaalset tagasisidet Sinu koostatud programmikoodi kohta.
                    </li>
                </ul>
                <p className="text">
                    Iganädalased ülesanded annavad kokku suure osa hindest.
                </p>
                <p className="text">
                    NB! 1. – 5. nädalal toimub paralleelselt meie ainega ka Programmeerimise täiendusõpe, mis on soovituslik.
                    Selles aines anname täiendavaid ülesandeid ja juhtnööre, et saaksid oma programmeerimisoskuse paremale tasemele viia.
                    Täiendusõpe ei ole kohustuslik, aga väga soovituslik!
                </p>
            </div>

            <div className="container">
                <h1 className="subtitle">
                    Iganädalased praktikumide ja loengute ajad
                </h1>
                <p className="text">
                    Loengud toimuvad paaritul nädalal teisipäeviti kell 12:00 ruumis U06A-229. Alates kolmandast nädalast toimuvad loengud ICT-121, ICT-122 klassides.
                    Loengud salvestatakse ja on järelvaadatavad YouTube'is.
                </p>
                <p className="text">
                    Lisaks loengutele toimuvad praktilised tunnid arvutiklassis, kus oleme kohal mitme õppejõuga, et saaks abi küsida.<br />
                    Kõik praktikumid toimuvad ruumides ICT-121, ICT-122.<br />
                    Praktikumide ajad nädala sees:
                    <ul className="list">
                        <li>Teisipäeval 14:00</li>
                        <li>Kolmapäeval 14:00</li>
                        <li>Neljapäeval 10:00</li>
                    </ul>
                    <br/>
                    Sessioonõppel toimuvad tunnid (loeng + praktikum) laupäeviti:
                    <ul className="list">
                        <li>9. septembril kell 14:45 - 16:30</li>
                        <li>23. septembril kell 13:30 - 15:15</li>
                        <li>7. oktoobril kell 13:30 - 15:15</li>
                        <li>21. oktoobril kell 13:30 - 15:15</li>
                        <li>4. novembril kell 15:15 - 17:00</li>
                        <li>18. novembril kell 15:15 - 17:00</li>
                        <li>2. detsembril kell 15:15 - 17:00</li>
                        <li>16. detsembril kell 15:15 - 17:00</li>
                    </ul>
                    <br />
                    Kõik vajalik info sessioonõppele räägitakse ära tavapärastes loengutes (teisipäeviti), mida saab YouTube'i kaudu järelvaadata.<br />
                    <br />
                    Täiendusõppe tunnid toimuvad järgmistel aegadel:
                    <ul className="list">
                        <li>Teisipäeval 16:00 - 19:15 (toimub 1. - 5. nädal)</li>
                        <li>Reedel 10:00 - 11:30 (toimub nädalatel 1, 2, 3, 5, 6)</li>
                        <li>Reedel 15:45 - 17:15 (toimub nädalatel 1, 2, 3, 5, 6)</li>
                    </ul>
                </p>
                <p className="text">
                    Tundide ajad on kättesaadavad tunniplaanis. Igaks juhuks tasub seda jooksvalt jälgida, kui mõni aeg peaks muutuma.
                    <strong>Võib külastada ükskõik millist praktikumi.</strong> Ka ühel nädalal võib mitmes käia. Midagi ei juhtu, kui praktikumi ei jõua.
                    Praktikumi eesmärk on anda võimaluse abiõppejõult küsida ja saada vahetut abi.
                </p>
                <p className="text">
                    Loengut ja praktikume on võimalik järele vaadata ka videona. Praktikumis tavaliselt mingit esitust/ettekannet ei toimu. 
                    Kui aga toimub, siis saab seda videona järele vaadata. Pigem on praktikumides abiõppejõud, 
                    kellele saab ülesandeid ette näidata ja kellelt saab oma koodi ja murede kohta personaalset abi.
                </p>
            </div>
            <div className="container">
                <h1 className="subtitle">
                    Tunnikontroll, kontrolltöö ja eksam
                </h1>
                <ul className="list">
                    <li>
                        Tunnikontroll toimub 5. nädalal (2. oktoober - 8. oktoober). 
                        Siin anname lahendamiseks väiksemad ja lihtsamad ülesanded selleks, et saada tagasisidet teie taseme kohta. 
                        <strong> Tunnikontrolli läbimine on vajalik, et saada eksamile. </strong>
                    </li>
                    <li>
                        Kontrolltöö toimub umbes 10. nädalal.
                        Siin anname lahendamiseks juba natuke mahukamad ülesanded. 
                        <strong> Kontrolltöö läbimine on vajalik, et saada eksamile.</strong>
                    </li>
                </ul>
                <p className="text">
                    Aine lõppeb eksamiga, mis toimub füüsiliselt ülikooli ruumides jaanuaris. 
                    Eksamil tuleb kooliarvutisse kirjutada toimiv programmikood ning vastata küsimustikule. 
                </p>
            </div>
            <div className="container">
                <h1 className="subtitle">
                    Süvendatud Pythoni lisakursus/ülesanded
                </h1>
                <p className="text">
                    Osade tudengite jaoks on tavalise algkursuse tempo aeglane ning nad tahaksid ennast proovile panna veel põnevamate ülesannetega.
                    Selleks oleme kursusele lisanud eraldi osa: süvendatud Pythoni alamkursus (me ise ütleme: süva-Python).
                    Sellest võivad osa võtta kõik - me isegi soovitame seda proovida kõikidel.
                    Süvendatud alamosa tähendab seda, et semestri jooksul pakume lahendamiseks mahukamaid ja põnevamaid ülesandeid.
                    Nende lahendamine on vabatahtlik.
                </p>
                <p className="text">
                    <strong>Süvendatud Pythoni ülesannete eest saab umbes 10% hindest. </strong>
                    See suuresti tähendab seda, et hinde "5" saamiseks on väga soovituslik mõni selline ülesanne lahendada.
                </p>
                <p className="text">
                    Paaris nädala teisipäeviti toimub süvendatud Pythoni praktikum, kus arutleme süva-Pythoni ülesannete üle ning saab vastavaid ülesandeid ette näidata.
                </p>
            </div>
            <div className="container">
                <h1 className="subtitle">
                    Kuidas tuleb kokku lõpphinne?
                </h1>
                <p className="text">
                    <strong>Kokku on kõigi tegevuste eest võimalik saada üle 1000 punkti. </strong>
                    See jaotub nii:
                </p>
                <ul className="list">
                    <li>
                        480 punkti saad Sa õigeaegselt tehtud ülesannete eest (iga nädal 32 punkti x 15 nädalat);
                    </li>
                    <li>
                        20 punkti saad kontrolltöö eest (10. nädalal);
                    </li>
                    <li>
                        100 ja rohkemgi punkti saad Sa boonusülesannete eest;
                    </li>
                    <li>
                        400 punkti on võimalik saada eksami eest;
                    </li>
                    <li>
                        Lisaks saab erinevate täiendavate tegevuste eest lisapunkte (lõplik maksimumsumma on isegi üle 1000 punkti).
                    </li>
                </ul>
                <p className="text">
                    Hinne kujuneb vastavalt punktidele nii:
                    <ul className="list">
                        <li>
                            901+ punkti → hinne "5"
                        </li>
                        <li>
                            801+ punkti → hinne "4"
                        </li>
                        <li>
                            701+ punkti → hinne "3"
                        </li>
                        <li>
                            601+ punkti → hinne "2"
                        </li>
                        <li>
                            501+ punkti → hinne "1"
                        </li>
                        <li>
                            500 punkti või vähem → hinne "0"
                        </li>
                    </ul>
                </p>
            </div>
            <form className="container" onSubmit={handleSubmit(onSubmit)}>
                <h1 className="subtitle form-question">
                    Kas aine korraldus, ajakava ja hindamise alused tunduvad selged?
                </h1>
                <div className="control">
                    <label className="radio">
                        <input type="radio" name="doesTimelineMakeSense" value="yes" ref={register({required: true})}/>
                        Jah, kõik arusaadav
                    </label>
                </div>
                <div className="control">
                    <label className="radio">
                        <input type="radio" name="doesTimelineMakeSense" value="question" ref={register({required: true})}/>
                        Tekkis mõni küsimus:
                        <input className="input" type="text" name="timelineQuestion" ref={register(createConditionalRequire(getValues, "doesTimelineMakeSense", "question"))}/>
                    </label>
                    
                </div>
                <div className="control">
                    <label className="radio">
                        <input type="radio" name="doesTimelineMakeSense" value="no" ref={register({required: true})}/>
                        Ei, jäi segaseks (täpsusta palun)
                        <textarea
                    className="textarea"
                    placeholder="Kirjuta oma mõtted siia"
                    name="timelineExplanation"
                    ref={register(createConditionalRequire(getValues, "doesTimelineMakeSense", "no"))}
                />
                    </label>
                </div>

                <h1 className="subtitle form-question">
                    Kuidas Sa tunned, kas saad selle ainega hakkama?
                </h1>
                <div className="control">
                    <label className="radio">
                        <input type="radio" name="canDoIt" value="yes" ref={register({required: true})}/>
                        Jah, olen arvestanud, et tegemist on väga ajamahuka ainega
                    </label>
                </div>
                <div className="control">
                    <label className="radio">
                        <input type="radio" name="canDoIt" value="yesButIntensive" ref={register({required: true})}/>
                        Pean selle aine jaoks oma kalendris veel ruumi vabastama
                    </label>
                </div>
                <div className="control">
                    <label className="radio">
                        <input type="radio" name="canDoIt" value="noTime" ref={register({required: true})}/>
                        Tundub, et see aine ei mahu mu ellu praegusel hetkel kohe kuidagi
                    </label>
                </div>
                <div className="control">
                    <label className="radio">
                        <input type="radio" name="canDoIt" value="problem" ref={register({required: true})}/>
                        Mul on mure (kirjuta kindlasti kommentaar)
                        <textarea
                    className="textarea"
                    placeholder="Kirjuta oma mure siia"
                    name="problemExplanation"
                    ref={register(createConditionalRequire(getValues, "canDoIt", "problem"))}
                />
                    </label>
                </div>

                {Object.keys(errors).length ? <div className="validation-error">
                    Jätkamiseks vasta palun kõigile küsimustele!
                </div> : null}
                <button className={`button is-large is-rounded take-test-button ${isLoading ? 'is-loading' : ''}`} disabled={isLoading}>JÄRGMINE →</button>
            </form>
        </section>
    </>);
}

export default TimelineAndGrading;
